import { Variant } from './Variant';

/**
 * Adds logic to the product option drop downs to return the variant id
 * @class
 */
export class VariantSelects {
  protected variantOptions: Array<any>;
  private variantData: any;
  public currentVariant: any;

  private variantContainer: HTMLElement;
  private onChangeCallback: { (): void };

  /**
   * @constructor
   * @param variantContainer Containing element of the options
   * @param onChangeCallback Method to call when selected options change
   */
  constructor(variantContainer: HTMLElement, onChangeCallback: { (): void }) {
    this.variantContainer = variantContainer;
    this.onChangeCallback = onChangeCallback;

    this.variantContainer.addEventListener('change', (event) => {
      this.onVariantChange();
    });

    this.updateVariantOptions();
    this.updateMasterId();
  }

  // Finds the option drop downs
  private getVariantSelect(): NodeListOf<HTMLSelectElement> {
    return this.variantContainer.querySelectorAll('select');
  }

  private updateVariantOptions(): void {
    this.variantOptions = Array.from(
      this.getVariantSelect(),
      (select) => select.value
    );
  }

  // Gets block of JSON from the page containing all variant options
  private getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.variantContainer.querySelector('[type="application/json"]')
          .textContent
      );
    return this.variantData;
  }

  // Finds the variant id based on the selected options
  private updateMasterId(): void {
    this.currentVariant = this.getVariantData().find((variant: Variant) => {
      return !variant.options
        .map((option: string, index: number) => {
          return this.variantOptions[index] === option;
        })
        .includes(false);
    });
  }

  // Function fired when user changes one of the selected options
  private onVariantChange(): void {
    this.updateVariantOptions();
    this.updateMasterId();

    if (this.onChangeCallback != null) {
      this.onChangeCallback();
    }
  }
}
